import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import apiurl from './apiurl';
import axios from 'axios';
import swal from 'sweetalert';
import NumberFormat from 'react-number-format';
import Zadanie_Pop from './Zadanie_Pop';
import Popup from "reactjs-popup";
import Opinie2 from './Opinie2';
import Opiniuj2 from './Opiniuj2';



export default class Opinie_wyb2 extends React.Component {
constructor(props) {
  super(props);    
  this.state = {
    token: sessionStorage.getItem('token'),
    DWBP1: '1',
    DWBP2: '2',
    datasort1: [],
    datasort2: [],
    datauwagi: [],
    open: false,
    open2: false,
    loadingdata: true,
    stanyZerowe: true,
  }
  this.closeModal = this.closeModal.bind(this);
  this.closeModal2 = this.closeModal2.bind(this);

  this.getdata();
  this.getuwagi();
}


closeModal () {
  this.setState({ open: false })
}

closeModal2 () {
  this.setState({ open2: false })
}

getdata = () => {
  axios
    .get(apiurl+"api/Opinie2/GetBudzet",{ params: { rok : this.props.rok, idUchwaly : this.props.idUchwaly, idWydzialu : this.props.idWydzialu, DWBP : this.state.DWBP1, rozdzial: '' },  headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ datasort1 : response.data, loadingdata: false }),
    )
    .catch(error => { swal(error.response.data.messege); this.setState({ loadingdata: false }) } );

  axios
    .get(apiurl+"api/Opinie2/GetBudzet",{ params: { rok : this.props.rok, idUchwaly : this.props.idUchwaly, idWydzialu : this.props.idWydzialu, DWBP : this.state.DWBP2, rozdzial: '' },  headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ datasort2 : response.data }),
    )
    .catch(error => swal(error.response.data.messege) );
}

getuwagi = () => {
  axios
    .get(apiurl+"api/Opinie/Uwagi",{ params: { rok : this.props.rok, idUchwaly : this.props.idUchwaly, idWydzial : this.props.idWydzialu },  headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ datauwagi: response.data }),
    )
    .catch(error => { swal(error.response.data); this.setState({ datauwagi: [] })} );
}

suma = (data, key) => {
  let total = 0;
  data.forEach((item, idx) => {
    let itemdot = item[key];
    let itemnum = parseFloat(itemdot);
    total += itemnum;
    total = parseFloat(total.toFixed(2));
  });
  return total;
};


render() {
  let { datasort1 , datasort2, loadingdata, stanyZerowe } = this.state;
  const sumWniosek1 = this.suma(datasort1, 'wniosek')
  const sumWniosek2 = this.suma(datasort2, 'wniosek');


return (
<React.Fragment>

<div className="container-fluid">
<h1>Opinia</h1>
<td><button class="btn btn-light button-text" onClick={() => ( ReactDOM.render(<Opinie2 rok={this.props.rok} idUchwaly={this.props.idUchwaly} idWydzialu={this.props.idWydzialu} />, document.getElementById("root")) )}>Wróć</button></td>
<div className="row m-2">
<div className="col-6">
<span><b>Dokument:</b> {this.props.nazwaUchwaly} <b>Wydział:</b> {this.props.nazwaWydzialu} </span><button class="btn btn-light ml-2" onClick={() => ( this.setState({ open2 : true }) )}>Opiniuj</button>
<div class="row">
  <label className='mr-3'>Pomiń stany zerowe:</label>
  {stanyZerowe ? (<input type="checkbox" checked={true} onClick={() => (this.setState({ stanyZerowe: false }))} ></input>) : (<input type="checkbox" checked={false} onClick={() => (this.setState({ stanyZerowe: true }))} ></input>)}
</div>

</div> 
<div className="col-6 card">
<h4>Uwagi:</h4>
{this.state.datauwagi.length > 0 ? (<div dangerouslySetInnerHTML={ { __html: this.state.datauwagi } }></div>) : (<p>Brak uwag</p>)}
<br></br>
</div>
</div>
<div className="fluid-row">
<ul className="nav nav-tabs" id="myTab" role="tablist">
  <li className="nav-item point">
    <a className="nav-link active" id="Prowizorium-tab" data-toggle="tab"  role="tab" aria-controls="Prowizorium" aria-selected="true" onClick={() => (this.setState({ DWBP1: "1" , DWBP2: "2",  loadingdata: true }, () => { this.getdata() }))}> Budżetowe</a>
  </li>
  <li className="nav-item point">
    <a className="nav-link" id="Autopoprawki-tab" data-toggle="tab"  role="tab" aria-controls="Autopoprawki" aria-selected="false" onClick={() => (this.setState({ DWBP1: "3" , DWBP2: "4",  loadingdata: true }, () => { this.getdata() }))}> Pozabudżetowe</a>
  </li>
</ul>
<div className="container-fluid card text-center">
{loadingdata ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null }

<h2 className="mt-2">Dochody</h2>
<table class="table">
  <thead>
  <tr >
    <th scope="col" class="text-center point" width="5%" ><b>Dział</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Rozdział</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Paragraf</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Pozycja</b></th>
    <th scope="col" class="text-center point" width="10%" ><b>Rodzaj</b></th>
    <th scope="col" class="text-center point" width="15%" ><b>Wydział</b></th>
    <th scope="col" class="text-center point" width="25%" ><b>Opis</b></th>
    <th scope="col" class="text-center point" width="10%" ><b>Przed</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Po</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Po Wniosku</b></th>    
    <th scope="col" class="text-center point" width="5%" ><b>Zmiany</b></th>    
    <th scope="col" class="text-center point" width="5%" ><b>Wniosek</b></th>
    <th scope="col" class="text-center"></th>
  </tr>
  </thead>
  <tbody>
    {datasort1.length > 0 ? (<>{datasort1.map((data, index) => {
  const { IDA, przed, po, dzial, rozdzial, paragraf, pozycja, p4, rodzajNazwa, wydzial,  wniosek, opis, poWniosku, zmiany, uchWydzStat, idWydzial, idRodzaj} = data;
  if(stanyZerowe && wniosek === 0) {
    return null 
  } else {
      return (<tr>
          <td ><p class="text-right">{dzial}</p></td>
          <td ><p class="text-right">{rozdzial}</p></td>
          <td ><p class="text-right">{paragraf}{p4}</p></td>
          <td ><p class="text-right">{pozycja}</p></td>
          <td ><p>{rodzajNazwa}</p></td>
          <td ><p>{wydzial}</p></td>
          <td ><p>{opis}</p></td>
          <td ><p class="text-right"><NumberFormat value={przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
          <td ><p class="text-right"><NumberFormat value={po} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td> 
          <td ><p class="text-right"><NumberFormat value={poWniosku} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
          <td ><p class="text-right"><NumberFormat value={zmiany} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>   
          <td class="text-right">
          {uchWydzStat === 'true' ?(
          <NumberFormat value={wniosek} class="form-control text-right" id={IDA} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} />
          ) :(<NumberFormat value={wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} />)
          }
          </td>
          <td><button class="btn btn-light button-text" onClick={() => this.setState({ idWydzialupop: idWydzial, idRodzpop: idRodzaj, dzialpop: dzial, rozdzialpop: rozdzial, pragrafp4pop: paragraf+p4, pozycjapop: pozycja, open: true, formularzpop : true , DWBP: this.state.DWBP1 })}> Zadania </button></td>
        </tr>);
      }
    })} 
    {(stanyZerowe & sumWniosek1 === 0) ? null : (<tr>
      <td colSpan={7} className='text-right'>SUMA</td>
      <td className='text-right' ><NumberFormat value={this.suma(datasort1, 'przed')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
      <td className='text-right' ><NumberFormat value={this.suma(datasort1, 'po')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
      <td className='text-right' ><NumberFormat value={this.suma(datasort1, 'poWniosku')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
      <td className='text-right' ><NumberFormat value={this.suma(datasort1, 'zmiany')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
      <td className='text-right' ><NumberFormat value={this.suma(datasort1, 'wniosek')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
      <td></td>
    </tr>)} 
    </>) : (<tr>
      <td colSpan="13"><center><b>Brak danych</b></center></td>
      </tr>)}
     
  </tbody>
</table>
<hr />
<h2 className="mt-2">Wydatki</h2>
<table class="table">
  <thead>
  <tr >
    <th scope="col" class="text-center point" width="5%" ><b>Dział</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Rozdział</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Paragraf</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Pozycja</b></th>
    <th scope="col" class="text-center point" width="10%" ><b>Rodzaj</b></th>
    <th scope="col" class="text-center point" width="15%" ><b>Wydział</b></th>
    <th scope="col" class="text-center point" width="25%" ><b>Opis</b></th>
    <th scope="col" class="text-center point" width="10%" ><b>Przed</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Po</b></th>
    <th scope="col" class="text-center point" width="5%" ><b>Po Wniosku</b></th>    
    <th scope="col" class="text-center point" width="5%" ><b>Zmiany</b></th>    
    <th scope="col" class="text-center point" width="5%" ><b>Wniosek</b></th>
    <th scope="col" class="text-center"></th>
  </tr>
  </thead>
  <tbody>
  {datasort2.length > 0 ? (<>{datasort2.map((data, index) => {
    const { IDA, przed, po, dzial, rozdzial, paragraf, pozycja, p4, rodzajNazwa, wydzial,  wniosek, opis, poWniosku, zmiany, uchWydzStat, idWydzial, idRodzaj} = data;
    if(stanyZerowe && wniosek === 0) {
      return null 
    } else {
      return (<tr>
          <td ><p class="text-right">{dzial}</p></td>
          <td ><p class="text-right">{rozdzial}</p></td>
          <td ><p class="text-right">{paragraf}{p4}</p></td>
          <td ><p class="text-right">{pozycja}</p></td>
          <td ><p>{rodzajNazwa}</p></td>
          <td ><p>{wydzial}</p></td>
          <td ><p>{opis}</p></td>
          <td ><p class="text-right"><NumberFormat value={przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td>
          <td ><p class="text-right"><NumberFormat value={po} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td> 
          <td ><p class="text-right"><NumberFormat value={poWniosku} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td>
          <td ><p class="text-right"><NumberFormat value={zmiany} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></p></td>   
          <td class="text-right">
          {uchWydzStat === 'true' ?(
          <NumberFormat value={wniosek} class="form-control text-right" id={IDA} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} />
          ) :(<NumberFormat value={wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} />)
          }
          </td>
          <td><button class="btn btn-light button-text" onClick={() => this.setState({ idWydzialupop: idWydzial, idRodzpop: idRodzaj, dzialpop: dzial, rozdzialpop: rozdzial, pragrafp4pop: paragraf+p4, pozycjapop: pozycja, open: true, formularzpop : true , DWBP: this.state.DWBP2 })}> Zadania </button></td>
        </tr>);
    }
  })}
  {(stanyZerowe & sumWniosek2 === 0) ? null : (<tr>
    <td colSpan={7} className='text-right'>SUMA</td>
    <td className='text-right' ><NumberFormat value={this.suma(datasort2, 'przed')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
    <td className='text-right' ><NumberFormat value={this.suma(datasort2, 'po')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
    <td className='text-right' ><NumberFormat value={this.suma(datasort2, 'poWniosku')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
    <td className='text-right' ><NumberFormat value={this.suma(datasort2, 'zmiany')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
    <td className='text-right' ><NumberFormat value={this.suma(datasort2, 'wniosek')} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} /></td>
    <td></td>
  </tr>)}
  </>) : (<tr><td colSpan="13"><center><b>Brak danych</b></center></td></tr>)}
  </tbody>
</table>
</div>
</div>
</div>

<Popup open={this.state.open} closeOnDocumentClick onClose={this.closeModal}>
<div class="okno">
<a class="close point" onClick={this.closeModal}>
&times;
</a>
<Zadanie_Pop token={this.state.token} rok= {this.props.rok} idUchwaly= {this.props.idUchwaly} dzial = {this.state.dzialpop} rozdzial = {this.state.rozdzialpop} paragrafP4 = {this.state.pragrafp4pop} pozycja = {this.state.pozycjapop} dwbp = {this.state.DWBP} idWydz = {this.state.idWydzialupop} idRodz = {this.state.idRodzpop} formularzpop = {this.state.formularzpop}/>
</div>
</Popup>
<Popup open={this.state.open2} closeOnDocumentClick onClose={this.closeModal2}>
<div class="oknouwagi">
<a class="close point" onClick={this.closeModal2}>
&times;
</a>
<Opiniuj2 idopini={this.props.idopini} rok={this.props.rok} idWydzialu={this.props.idWydzialu} idUchwaly= {this.props.idUchwaly} uwagi={this.props.uwagi} closeModal2={this.closeModal2} />
</div>
</Popup>
</React.Fragment>
);
}
}
